<ul
  *ngIf="choices?.length > 0"
  #dropdownMenu
  class="dropdown-menu"
  [style.top.px]="position?.top"
  [style.left.px]="position?.left"
>
  <li
    *ngFor="let choice of choices; trackBy: trackById"
    [ngClass]="{
      'dropdown-item c-pointer': choice.type !== 'divider',
      'dropdown-divider': choice.type === 'divider',
    }"
    [class.active]="activeChoice === choice"
    (click)="selectChoice.next(choice)"
  >
    {{ choice.name }}
  </li>
</ul>
